<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const props = defineProps<{
  config: unknown
}>()

const chartCanvas = ref<HTMLCanvasElement | null>(null)
let chartInstance: Chart | null = null

const render = () => {
  // Distruggi il grafico precedente
  if (chartInstance) {
    chartInstance.destroy()
  }
  // Crea il nuovo grafico
  if (chartCanvas.value) {
    const configClone = JSON.parse(JSON.stringify(props.config))
    chartInstance = new Chart(chartCanvas.value, configClone)
  }
}

onMounted(() => {
  render()
})

// Ridisegna se la config cambia
watch(
  () => props.config,
  () => {
    render()
  },
  { deep: true },
)

onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.destroy()
    chartInstance = null
  }
})
</script>

<template>
  <canvas ref="chartCanvas" />
</template>
